import {Field, FieldRenderProps} from "react-final-form";
import React from "react";
import * as SmoothUI from "@smooth-ui/core-sc";
import {UncontrolledPopover, PopoverHeader, PopoverBody} from 'reactstrap';
interface HOCFormGroupXXXProps {
    prefix: string,
    valuePropertyKey: string,
    label: string,
    placeholder: string,
    subtext?: string,
    validate: (i:string|null) => string | undefined,
    infotext?: string, 
    labelList?: string[],
    valueList?: string[],
}

type FieldRenderPropsWithPlaceholder = FieldRenderProps<any, HTMLElement> & {
    placeholder: string
}

const HOCFormGroupXXX = (component : React.ComponentType<any>) => (props : HOCFormGroupXXXProps) => {
    let {prefix, valuePropertyKey, label, placeholder, validate, subtext, infotext} = props;
    let popover = <div></div>; 

    if(!validate)
        validate = () => undefined;

    if(!placeholder)
        placeholder = '';
    if (infotext){
        popover = (<span>
                        <svg xmlns="http://www.w3.org/2000/svg"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            className={'feather'}
                            id="InfoPopover"
                            style={{width: 20, height: 20, marginLeft: 5}}
                            >
                                <use xlinkHref="/svg/joto.svg#info"/>
                            </svg>
                        <UncontrolledPopover trigger="focus" target="InfoPopover">
                            <PopoverHeader>{label}</PopoverHeader>
                            <PopoverBody style={{fontSize: "1.2rem"}}>{infotext}</PopoverBody>
                        </UncontrolledPopover>
                    </span>)
    } 
    const id = prefix + '-' + valuePropertyKey;

    return <Field name={valuePropertyKey}
                  placeholder={placeholder}
                  parse={value => value}
                  validate={validate}
    >
        {(fieldState : FieldRenderPropsWithPlaceholder) => {
            const {input, meta, placeholder} = fieldState;
            return <SmoothUI.FormGroup>
                <SmoothUI.Label htmlFor={id}>{label}</SmoothUI.Label>   
                {popover}
                {subtext? <p className="subtext">{subtext}</p>: null}
                {React.createElement(component, {...input, placeholder, control:true})}
                <SmoothUI.ControlFeedback valid={!(meta.error && meta.touched)}>{(meta.error && meta.touched) ? meta.error : (meta.touched ? <span>Ok</span> : <span>&nbsp;</span>)}</SmoothUI.ControlFeedback>
            </SmoothUI.FormGroup>;
        }}
    </Field>;
};




const FormGroupSelect = (props : HOCFormGroupXXXProps) => {
    let {prefix, valuePropertyKey, label, placeholder, validate, subtext, valueList, labelList} = props;

    if(!validate)
        validate = () => undefined;

    if(!placeholder)
        placeholder = '';

    const id = prefix + '-' + valuePropertyKey;

    let options: JSX.Element[]  = []; 
    if (valueList && labelList){
        for (let i = 0; i < valueList.length; i++){
            options.push(
                <option key={i} value={valueList[i]} >{labelList[i]}</option>
            )
        }
    }
    return <Field name={valuePropertyKey}
                  placeholder={placeholder}
                  parse={value => value}
                  validate={validate}
    >
        {(fieldState : FieldRenderPropsWithPlaceholder) => {
            const {input, meta, placeholder} = fieldState;
            return <SmoothUI.FormGroup>
                <SmoothUI.Label htmlFor={id}>{label}</SmoothUI.Label>
                {subtext? <p className="subtext">{subtext}</p>: null}
                
                {React.createElement(SmoothUI.Select, {...input, placeholder, control:true}, options)}
                <SmoothUI.ControlFeedback valid={!(meta.error && meta.touched)}>{(meta.error && meta.touched) ? meta.error : (meta.touched ? <span>Ok</span> : <span>&nbsp;</span>)}</SmoothUI.ControlFeedback>
            </SmoothUI.FormGroup>;
        }}
    </Field>;
};


const FormGroupInput = HOCFormGroupXXX(SmoothUI.Input);
const FormGroupTextarea = HOCFormGroupXXX(SmoothUI.Textarea);

export {FormGroupInput, FormGroupTextarea, FormGroupSelect}
